<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="loadingIpi" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">IPI</h2>
    <QuadroAlerta
      :classe="nomeImposto"
      :alerta="dadosAlerta"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :key="getRenderKey"
      :borderTop="!exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <PerguntasIpi
        class="perguntas-ipi-container"
        :imposto="imposto"
        :seleciona="selecionaPergunta"
        :perguntaSelecionada="perguntaSelecionada"
        :selecionouPerguntaIpi="selecionouPerguntaIpi"
        :edita="editaPergunta"
      />
      <RespostasIpi
        :imposto="imposto"
        :seleciona="selecionaResposta"
        :respostaSelecionada="respostaSelecionada"
        :selecionouRespostaIpi="selecionouRespostaIpi"
        :edita="editaResposta"
      />
    </QuadroPrincipal>
  </div>
</template>

<script>
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import PerguntasIpi from "@/components/PerguntasIpi/PerguntasIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RespostasIpi from "@/components/RespostasIpi/RespostasIpi.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "Ipi",

  props: {
    id: String | Number,
    buscarImposto: Function,
    dadosForm: Array | Object,
    tributoAtivo: String,
    limparImpostos: Boolean
  },

  components: {
    LoadingResultado,
    PerguntasIpi,
    QuadroAlerta,
    QuadroPrincipal,
    MensagemErro,
    RespostasIpi
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "IPI",
      nomeImposto: "ipi",
      imposto: null,
      perguntaSelecionada: {},
      respostaSelecionada: {},
      selecionouPerguntaIpi: false,
      requerRespostaIpi: true,
      selecionouRespostaIpi: false,
      erro: false,
      loadingIpi: false
    };
  },

  updated() {
    if (this.selecionouIpi) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      this.loadingIpi = true;
      if (newValue == this.nomeImposto && !this.imposto) {
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              this.erro = true;
              this.loadingIpi = false;
              console.error(error);
            }
          }
        }
      }
      this.loadingIpi = false;
    },

    loadingIpi() {
      this.$emit("loading", this.loadingIpi);
    },

    selecionouIpi() {
      this.setSelecao({ selecao: { selecionouIpi: this.selecionouIpi }, id: this.id });
    }
  },

  async created() {
    this.setSelecao({ selecao: { selecionouIpi: this.selecionouIpi }, id: this.id });
    this.loadingIpi = true;
    if (this.tributoAtivo == this.nomeImposto && this.dadosForm.tipoOperacao != 41) {
      let tentativas = 0;
      while (tentativas < 3) {
        try {
          [this.imposto] = await this.buscarImposto({
            imposto: this.nomeImposto,
            idCenario: this.id
          });
          tentativas = 3;
        } catch (error) {
          tentativas++;
          console.error(`${tentativas}ª tentativa`);
          if (tentativas === 3) {
            this.erro = true;
            this.loadingIpi = false;
            console.error(error);
          }
        }
      }
    }
    this.loadingIpi = false;
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    inaplicabilidade() {
      if (
        this.perguntaSelecionada &&
        this.perguntaSelecionada.descricao &&
        this.perguntaSelecionada.descricao.toLowerCase().includes("inaplicabilidade")
      ) {
        return true;
      }
      return false;
    },
    selecionouIpi() {
      const selecionou = [
        this.selecionouPerguntaIpi,
        !this.requerRespostaIpi || this.selecionouRespostaIpi
      ];
      return !selecionou.filter(boolean => boolean == false).length;
    },
    // loading() {
    //   this.$emit("loading", !this.imposto || this.loadingIpi);
    //   return !this.imposto || this.loadingIpi;
    // },
    dadosAlerta() {
      let alerta = this.imposto.dados.filter(imposto => imposto.ordem == 101);
      return !!alerta.length ? alerta : null;
    },

    impressaoLog() {
      let log = {
        logIpi: {
          perguntas: this.perguntaSelecionada,
          respostas: this.respostaSelecionada
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("form", ["setDadosForm"]),
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    async selecionaPergunta(imposto) {
      this.perguntaSelecionada = imposto;
      this.selecionouPerguntaIpi = true;

      //Seta a regra selecionada no forms, outros impostos precisam saber a regra.
      // this.dadosForm.regra = imposto.id_regra;
      // this.setDadosForm({ id: this.id, dadosForm: this.dadosForm });
      let dados = { ...this.dadosForm, regra: imposto.id_regra };
      this.setDadosForm({ id: this.id, dadosForm: dados });
      //fim
      if (!this.inaplicabilidade) {
        this.loadingIpi = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            const [response] = await this.buscarImposto({
              imposto: "ipi_respostas",
              idCenario: this.id
            });
            this.imposto = response;
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.loadingIpi = false;
            }
          }
        }
        this.loadingIpi = false;

        // VERIFICA SE REQUER SELEÇÃO PARA IMPRESSÃO
        this.requerRespostaIpi = this.imposto
          ? !!this.imposto.dados.filter(imposto => imposto.ordem != 101).length
          : true;
      } else {
        this.requerRespostaIpi = false;
      }
      this.$emit("limparImpostos", false);
    },

    editaPergunta() {
      this.perguntaSelecionada = {};
      this.selecionouPerguntaIpi = false;
      this.imposto.dados = [];
      this.$emit("limparImpostos", true);

      this.dadosForm.regra = 0;
      if (this.dadosForm.aliquotaIcmsSelecionada) {
        delete this.dadosForm.aliquotaIcmsSelecionada;
      }
      this.setDadosForm({ id: this.id, dadosForm: this.dadosForm });

      this.editaResposta();
    },

    async selecionaResposta(imposto) {
      this.respostaSelecionada = imposto;
      this.selecionouRespostaIpi = true;
    },

    editaResposta() {
      this.respostaSelecionada = {};
      this.selecionouRespostaIpi = false;
    }
  }
};
</script>

<style lang="scss" scoped>
// .perguntas-ipi-container {
// }
</style>
